import { useMemo } from 'react';
import { Suggestion } from 'react-places-autocomplete';
import { Props as SelectProps } from 'react-select';
import { Select } from '../form/Select/Select';

export type OptionType = { label: string; value: Suggestion };

export type SelectAutocompleteProps = SelectProps<OptionType>;

export type PlacesSelectProps = Omit<SelectAutocompleteProps, 'options'> & {
  suggestions: readonly Suggestion[];
};

export function suggestionToOption(suggestion: Suggestion): OptionType {
  return {
    label: suggestion.description,
    value: suggestion,
  };
}

export const PlacesSelect = ({ suggestions, ...props }: PlacesSelectProps) => {
  const options = useMemo(() => suggestions.map(suggestionToOption), [suggestions]);
  const selectProps: SelectAutocompleteProps = {
    ...props,
    options,
  };
  return <Select {...selectProps} />;
};
